import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=4a6fb9dd&scoped=true"
import script from "./categoryManage.vue?vue&type=script&lang=js"
export * from "./categoryManage.vue?vue&type=script&lang=js"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=4a6fb9dd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6fb9dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6fb9dd')) {
      api.createRecord('4a6fb9dd', component.options)
    } else {
      api.reload('4a6fb9dd', component.options)
    }
    module.hot.accept("./categoryManage.vue?vue&type=template&id=4a6fb9dd&scoped=true", function () {
      api.rerender('4a6fb9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/categoryManage/categoryManage.vue"
export default component.exports